export default "__VITE_ASSET__D21OuI7O__"